import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './routes/ProtectedRoute';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import Products from './pages/Products';
import ProductsEnhanced from './pages/ProductsEnhanced';
import Branches from './pages/Branches';
import Inventory from './pages/Inventory';
import AIAnalytics from './pages/AIAnalytics';
import Settings from './pages/Settings';
import Profile from './pages/Profile';

// Quick Placeholders for remaining modules
const Placeholder = ({ title }) => (
  <div className="text-center py-5">
    <h2 className="fw-bold mb-3">{title} Module</h2>
    <p className="text-muted">This module is part of the Enterprise OS core.</p>
    <div className="glass-card p-5 mt-4 d-inline-block">
      <div className="spinner-border text-primary" role="status"></div>
    </div>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<MainLayout><Dashboard /></MainLayout>} />
            <Route path="/profile" element={<MainLayout><Profile /></MainLayout>} />
            <Route path="/orders" element={<MainLayout><Orders /></MainLayout>} />
            <Route path="/products" element={<MainLayout><ProductsEnhanced /></MainLayout>} />
            <Route path="/inventory" element={<MainLayout><Inventory /></MainLayout>} />
            <Route path="/branches" element={<MainLayout><Branches /></MainLayout>} />
            <Route path="/vendors" element={<MainLayout><Placeholder title="Vendor Management" /></MainLayout>} />
            <Route path="/employees" element={<MainLayout><Placeholder title="HR & Employee" /></MainLayout>} />
            <Route path="/delivery" element={<MainLayout><Placeholder title="Logistics & Delivery" /></MainLayout>} />
            <Route path="/analytics" element={<MainLayout><AIAnalytics /></MainLayout>} />
            <Route path="/settings" element={<MainLayout><Settings /></MainLayout>} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
